import React, { useState } from "react";

import { useAuth } from "../../context/AuthContext";
import email from "../../assets/images/email.png";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useNotification } from "../../context/NotificationProvider";
import { unsubscribeEmail } from "../../services/settingsService";
const CancelEmail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { userProfile } = useAuth();
  const { user } = useAuth0();
  const { showMessage } = useNotification();
  const userId = userProfile?._id;

  const navigate = useNavigate();

  const cancelEmail = async () => {
    setIsLoading(true);
    try {
      const response = await unsubscribeEmail(userId);
      showMessage("success", "Email verified!");
      navigate("/");
      return response;
    } catch (error) {
      showMessage("error", "There was an issue unsubscribing your email.");
    } finally {
      setIsLoading(false);
    }
  };

  // const confirm = async () => {
  //   setIsLoading(true);

  //   try {
  //     const response = await unsubscribeEmail(userId);
  //     if (response?.status != 200 && !response.data.data) {
  //       setIsLoading(false);
  //       return;
  //     }

  //     const user = response.data.data;

  //     if (!user?.email_verified) {
  //       showMessage("error", "Email not verified.");
  //       setIsLoading(false);
  //       return;
  //     }

  //     showMessage("success", "Email verified!");
  //     setAuth0Profile(user);

  //     navigate("/");
  //   } catch (error) {
  //     showMessage(
  //       "error",
  //       "There was an issue confirming your email as verified."
  //     );
  //   }
  // };

  return (
    <>
      <div className="relative min-h-screen flex flex-col items-center justify-center bg-white text-">
        <div className="z-10 mt-1 flex flex-col items-center space-y-6">
          <img
            src={email}
            alt="Verified"
            width={100}
            height={100}
            className="mx-auto"
          />
          <h2 className="mt-6 text-2xl font-bold text-brand-primary">
            Need a break from our emails?
          </h2>
          <p className="text-sm text-center text-gray-600 max-w-md">
            Want to stop hearing from us? Just click the button below to
            unsubscribe {user?.email || ""} from future emails.
          </p>
          <button
            onClick={cancelEmail}
            disabled={isLoading}
            className={`mt-6 h-14 w-96 rounded-full font-semibold text-white transition-transform duration-200 shadow-lg ${
              isLoading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 transform hover:scale-105"
            }`}
          >
            {isLoading ? "Cancelling..." : "Unsubscribe"}
          </button>
        </div>

        {/* Bottom Gradient Overlay */}
        <div className="absolute bottom-0 left-0 w-full h-64 bg-gradient-to-t from-bg-light-gray-2 to-transparent pointer-events-none" />
      </div>
    </>
  );
};

export default CancelEmail;
